import { render } from "./EditMenuCustom.vue?vue&type=template&id=1bdc7cd2&scoped=true"
import script from "./EditMenuCustom.vue?vue&type=script&lang=js"
export * from "./EditMenuCustom.vue?vue&type=script&lang=js"

import "./EditMenuCustom.vue?vue&type=style&index=0&id=1bdc7cd2&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdc7cd2"]])

export default __exports__